module.exports = __webpack_public_path__ + "media/images/drop-icon-4c30747a238ee9085c768bffb9082272.svg";